import React from 'react';
import { AsyncEditPriorityMappingModal } from '@atlassian/jira-servicedesk-incident-management-priority-mapping-modal/src/async.tsx';
import type { JiraPriorities } from '@atlassian/jira-servicedesk-incident-management-priority-mapping-modal/src/common/types.tsx';
import type { ModalProps } from '../../types.tsx';

type CloudId = string;

export type EditPriorityMappingModalOptions = Readonly<{
	cloudId: CloudId;
	priorities?: JiraPriorities;
	defaultPriorityId?: string;
}>;

type Props = EditPriorityMappingModalOptions & ModalProps;

const EditPriorityMapping = ({ cloudId, onClose, priorities, defaultPriorityId }: Props) => (
	<AsyncEditPriorityMappingModal
		cloudId={cloudId}
		onClose={onClose}
		jiraPriorities={priorities}
		defaultJiraPriorityId={defaultPriorityId}
	/>
);

export default EditPriorityMapping;
